/**
 * Morph SVGs with anime.js and flubber
 */

const threshold = (steps) => {
  
  if (!steps) {
    return;
  }

  let thresholds = []

  for (var i = 1.0; i <= steps; i++) {
    const ratio = i / steps;
    thresholds.push(ratio);
  }

  thresholds.push(0);

  return thresholds;

}

const morph = (from, to, duration) => {

  if (!from && !to) {
    return;
  }

  const target = from ? from : to;
  const shape = 'M180.326 255.805H180.46C178.688 255.437 157.358 250.9 140.892 239.995C123.699 228.587 76.8 178.842 75.8887 177.756C74.9773 176.671 55.634 155.648 49.49 118.108C49.49 118.108 32.256 103.137 49.49 88.9037C66.7239 74.6701 73.3696 73.1853 73.3696 73.1853C73.3696 73.1853 74.752 66.8365 88.8832 49.5616C103.014 32.2867 118.088 49.4796 118.088 49.4796C155.638 55.5212 176.722 74.8544 177.807 75.7145C178.893 76.5747 228.772 123.371 240.21 140.534C251.3 157.174 255.877 178.811 256.143 180.111C256.87 176.701 261.478 156.611 271.872 140.933C283.259 123.74 333.005 76.8 334.08 75.9296C335.155 75.0592 356.198 55.6749 393.738 49.5206C393.738 49.5206 408.709 32.2969 422.943 49.5206C437.176 66.7443 438.651 73.4105 438.651 73.4105C438.651 73.4105 445.01 74.7315 462.275 88.9139C479.539 103.096 462.367 118.129 462.367 118.129C456.315 155.679 436.992 176.763 436.122 177.848C435.251 178.934 388.465 228.813 371.313 240.251C354.161 251.689 331.674 256.195 331.674 256.195H331.551C333.312 256.563 354.642 261.1 371.108 272.005C388.301 283.392 435.241 333.138 436.111 334.223C436.982 335.309 456.366 356.332 462.51 393.871C462.51 393.871 479.744 408.842 462.51 423.076C445.276 437.309 438.63 438.794 438.63 438.794C438.63 438.794 437.299 445.143 423.117 462.418C408.934 479.693 393.912 462.5 393.912 462.5C356.362 456.458 335.278 437.125 334.193 436.265C333.107 435.405 283.228 388.608 271.79 371.446C260.7 354.806 256.123 333.169 255.857 331.868C255.13 335.278 250.522 355.369 240.128 371.046C228.741 388.239 178.995 435.179 177.92 436.05C176.845 436.92 155.802 456.305 118.262 462.459C118.262 462.459 103.291 479.683 89.0573 462.459C74.8237 445.235 73.3492 438.569 73.3492 438.569C73.3492 438.569 66.9901 437.248 49.7255 423.086C32.4608 408.924 49.6333 393.871 49.6333 393.871C55.6852 356.352 75.008 335.237 75.8784 334.152C76.7488 333.066 123.535 283.187 140.687 271.749C157.839 260.311 180.326 255.805 180.326 255.805Z';

  const interpolator = flubber.interpolate(
    from ? from.querySelector('path').getAttribute('d') : shape,
    to ? to.querySelector('path').getAttribute('d') : shape
  );

  target.classList.add('is-morphing');

  let val = { prop: 0 }

  anime({
    targets: val,
    prop: 1,
    duration: duration ? duration : 500,
    easing: 'easeInOutCubic',
    update() {
      target.querySelector('path').setAttribute('d', interpolator(val.prop));
    },
    complete() {
      target.classList.remove('is-morphing');
    }
  });

}

const morph_on_scroll = el => {

  // path transition only supported by chromium browsers
  if (!window.chrome) {
    return;
  }

  if (!el) {
    return;
  }

  let ratio = 0;

  const target = el.querySelector('path');
  const shape = 'M180.326 255.805H180.46C178.688 255.437 157.358 250.9 140.892 239.995C123.699 228.587 76.8 178.842 75.8887 177.756C74.9773 176.671 55.634 155.648 49.49 118.108C49.49 118.108 32.256 103.137 49.49 88.9037C66.7239 74.6701 73.3696 73.1853 73.3696 73.1853C73.3696 73.1853 74.752 66.8365 88.8832 49.5616C103.014 32.2867 118.088 49.4796 118.088 49.4796C155.638 55.5212 176.722 74.8544 177.807 75.7145C178.893 76.5747 228.772 123.371 240.21 140.534C251.3 157.174 255.877 178.811 256.143 180.111C256.87 176.701 261.478 156.611 271.872 140.933C283.259 123.74 333.005 76.8 334.08 75.9296C335.155 75.0592 356.198 55.6749 393.738 49.5206C393.738 49.5206 408.709 32.2969 422.943 49.5206C437.176 66.7443 438.651 73.4105 438.651 73.4105C438.651 73.4105 445.01 74.7315 462.275 88.9139C479.539 103.096 462.367 118.129 462.367 118.129C456.315 155.679 436.992 176.763 436.122 177.848C435.251 178.934 388.465 228.813 371.313 240.251C354.161 251.689 331.674 256.195 331.674 256.195H331.551C333.312 256.563 354.642 261.1 371.108 272.005C388.301 283.392 435.241 333.138 436.111 334.223C436.982 335.309 456.366 356.332 462.51 393.871C462.51 393.871 479.744 408.842 462.51 423.076C445.276 437.309 438.63 438.794 438.63 438.794C438.63 438.794 437.299 445.143 423.117 462.418C408.934 479.693 393.912 462.5 393.912 462.5C356.362 456.458 335.278 437.125 334.193 436.265C333.107 435.405 283.228 388.608 271.79 371.446C260.7 354.806 256.123 333.169 255.857 331.868C255.13 335.278 250.522 355.369 240.128 371.046C228.741 388.239 178.995 435.179 177.92 436.05C176.845 436.92 155.802 456.305 118.262 462.459C118.262 462.459 103.291 479.683 89.0573 462.459C74.8237 445.235 73.3492 438.569 73.3492 438.569C73.3492 438.569 66.9901 437.248 49.7255 423.086C32.4608 408.924 49.6333 393.871 49.6333 393.871C55.6852 356.352 75.008 335.237 75.8784 334.152C76.7488 333.066 123.535 283.187 140.687 271.749C157.839 260.311 180.326 255.805 180.326 255.805Z';

  const interpolator = flubber.interpolate(
    shape,
    target.getAttribute('d'),
    {
      maxSegmentLength: 3
    }
  );

  const observer = new IntersectionObserver((entries, observer) => {
    ratio = parseFloat(entries[0].intersectionRatio.toFixed(2));

    if (ratio < 0.25 && ratio > 0.75)  {
      return;
    }

    target.setAttribute('d', interpolator(ratio));
  }, {
    threshold: threshold(50)
  });

  observer.observe(el);

}

// const morph_on_scroll = el => {

//   if (!el) {
//     return;
//   }

//   let last_value = 0;
//   let ratio = 0;
//   let morphing = false;

//   const target = el.querySelector('path');
//   const to = 'M256 363.653C250.788 366.131 246.374 373.146 242.606 377.201C237.486 382.659 232.366 388.086 227.185 393.431C216.545 404.367 205.558 414.997 193.915 424.878C168.786 446.208 141.691 460.718 111.186 472.74C93.3274 490.926 105.626 503.214 71.4753 440.689C8.93958 406.528 21.2276 418.816 39.4138 400.968C51.4049 370.463 65.9457 343.368 87.2756 318.239C97.1572 306.596 107.756 295.608 118.723 284.969C124.068 279.757 129.495 274.637 134.953 269.548C139.049 265.738 146.217 261.284 148.562 256C146.166 250.716 139.039 246.262 134.953 242.453C129.495 237.333 124.068 232.213 118.723 227.031C107.776 216.392 97.1572 205.404 87.2756 193.761C65.9457 168.632 51.4356 141.537 39.4138 111.032C21.2276 93.1841 8.93958 105.472 71.465 71.3217C105.626 8.78601 93.3274 21.074 111.186 39.2603C141.691 51.2513 168.786 65.7921 193.915 87.122C205.558 97.0036 216.545 107.602 227.185 118.569C232.448 123.904 237.568 129.342 242.606 134.799C246.374 138.895 250.798 145.869 256 148.347C261.212 145.869 265.626 138.854 269.394 134.799C274.514 129.342 279.634 123.914 284.815 118.569C295.455 107.633 306.442 97.0036 318.085 87.122C343.214 65.7921 370.309 51.282 400.814 39.2603C418.673 21.074 406.374 8.78601 440.525 71.3114C503.061 105.472 490.773 93.1841 472.586 111.032C460.595 141.537 446.054 168.632 424.725 193.761C414.843 205.404 404.245 216.392 393.277 227.031C387.932 232.243 382.505 237.363 377.047 242.453C372.951 246.262 365.834 250.716 363.438 256C365.834 261.284 372.961 265.738 377.047 269.548C382.505 274.668 387.932 279.788 393.277 284.969C404.224 295.608 414.843 306.596 424.725 318.239C446.054 343.368 460.565 370.463 472.586 400.968C490.773 418.826 503.061 406.528 440.535 440.678C406.374 503.214 418.673 490.926 400.814 472.74C370.309 460.749 343.214 446.208 318.085 424.878C306.442 414.997 295.455 404.398 284.815 393.431C279.603 388.086 274.483 382.659 269.394 377.201C265.626 373.146 261.212 366.131 256 363.653Z';
  
//   const interpolator = flubber.interpolate(
//     target.getAttribute('d'),
//     to,
//     {
//       maxSegmentLength: 2
//     }
//   );

//   target.setAttribute('d', interpolator(1));

//   const observer = new IntersectionObserver((entries, observer) => {

//     // TODO: invert scroll direction
//     ratio = parseFloat(entries[0].intersectionRatio.toFixed(2));

//     if (ratio < 0 && ratio > 1)  {
//       return;
//     }

//     let val = { prop: last_value }
  
//     if (morphing) {
//       return;
//     }

//     morphing = true;

//     anime({
//       targets: val,
//       prop: ratio,
//       duration: 750,
//       easing: 'easeInOutCubic',
//       update() {
//         target.setAttribute('d', interpolator(val.prop));
//       },
//       complete() {
//         morphing = false;

//         if (!el.classList.contains('is-morphed')) {
//           el.classList.add('is-morphed');
//           return;
//         }
//       }
//     });

//     last_value = ratio;

//   }, {
//     threshold: threshold(20)
//   });

//   observer.observe(el);

// }